import { SettingsState } from './types'

export const state: SettingsState = {
  appSettings: null,
  languageSettings: null,
  themeSettings: null,
  environment: null,
  oneRiskSettings: null
}
